export default file => () => import('@/views/' + file + '/index.vue')



// WEBPACK FOOTER //
// ./src/router/_import.js